(() => {
  const COMPONENT_NAME = "newsletter-bar-form";
  const KLAVIYO_SUBSCRIBE_URL =
    "https://manage.kmail-lists.com/ajax/subscriptions/subscribe";

  if (customElements.get(COMPONENT_NAME)) return;

  const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  class NewsletterBarForm extends HTMLElement {
    #form = null;
    #emailInput = null;
    #submitButton = null;
    #message = null;
    #listId = "";
    #isSubmitting = false;

    connectedCallback() {
      this.#form = this.querySelector("form");
      this.#emailInput = this.querySelector("[data-newsletter-email]");
      this.#submitButton = this.querySelector("[data-newsletter-submit]");
      this.#message = this.querySelector("[data-newsletter-message]");
      this.#listId = this.dataset.listId?.trim() ?? "";

      this.#form?.addEventListener("submit", this.#handleSubmit);
    }

    disconnectedCallback() {
      this.#form?.removeEventListener("submit", this.#handleSubmit);
    }

    #handleSubmit = async (event) => {
      event.preventDefault();

      if (this.#isSubmitting || !this.#emailInput || !this.#submitButton)
        return;

      const email = this.#emailInput.value.trim();

      this.#clearMessage();
      this.#emailInput.removeAttribute("aria-invalid");

      if (!isValidEmail(email)) {
        this.#showMessage("error", this.dataset.errorInvalid);
        this.#emailInput.setAttribute("aria-invalid", "true");
        this.#emailInput.focus();
        return;
      }

      if (!this.#listId) {
        this.#showMessage("error", this.dataset.errorConfig);
        return;
      }

      this.#isSubmitting = true;
      this.#submitButton.disabled = true;

      try {
        const formData = new FormData();
        formData.append("g", this.#listId);
        formData.append("email", email);

        const response = await fetch(KLAVIYO_SUBSCRIBE_URL, {
          method: "POST",
          body: formData,
          headers: {
            Accept: "application/json, text/javascript, */*; q=0.01",
          },
        });

        const isSuccess = await this.#parseSuccess(response);

        if (!isSuccess) {
          throw new Error("Subscription failed");
        }

        this.#showMessage("success", this.dataset.successMessage);
        this.#form.reset();
      } catch {
        this.#showMessage("error", this.dataset.errorSubmit);
        this.#emailInput.setAttribute("aria-invalid", "true");
      } finally {
        this.#isSubmitting = false;
        this.#submitButton.disabled = false;
      }
    };

    async #parseSuccess(response) {
      const contentType = response.headers.get("content-type") ?? "";

      if (contentType.includes("application/json")) {
        const data = await response.json();
        return data?.success === true || data?.is_subscribed === true;
      }

      const text = await response.text();

      if (!response.ok) return false;

      return (
        text.includes('"success":true') ||
        text.includes('"is_subscribed":true') ||
        text.includes("Thank")
      );
    }

    #clearMessage() {
      if (!this.#message) return;

      this.#message.textContent = "";
      this.#message.hidden = true;
      this.#message.classList.remove(
        "newsletter-bar__message--success",
        "newsletter-bar__message--error",
      );
    }

    #showMessage(type, message) {
      if (!this.#message || !message) return;

      this.#message.textContent = message;
      this.#message.hidden = false;
      this.#message.classList.add(`newsletter-bar__message--${type}`);
    }
  }

  customElements.define(COMPONENT_NAME, NewsletterBarForm);
})();
